<template>
    <Spinner v-if="isLoading" />
    
    <div class="profile-view-left card col-12 md:col-6"> 
        
        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.name.$invalid && submited}">{{ translated('name') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText ref="nameInputControl" :disabled="locked" type="text" v-model="name"/>
                <!-- disabled || !unlockedAll -->
            </div>                
        </div>

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.surname.$invalid && submited}">{{ translated('surname') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="locked" type="text" v-model="surname"/>
            </div>
        </div>

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.personalregistrationnumber.$invalid && submited}">{{ translated('personalregistrationnumber') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="locked" type="text" v-model="personalregistrationnumber" @keyup="JMBGKeyDown" />
                <!-- @blur=JMBGLostFocus -->
            </div>
        </div>

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.personBirthDate.$invalid && submited}">{{ translated('birthday') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <Calendar disabled :label="translated('homeVisitDate')" inputId="icon" v-model="personBirthDate" :showIcon="true" dateFormat="dd-mm-yy"  :manualInput="false" :minDate="new Date(1920, 0, 1)"/>  
            </div>
        </div>                  

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.parentName.$invalid && submited}">{{ translated('parentName') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="locked" type="text" v-model="parentName"/>
            </div>
        </div>

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.gender.$invalid && submited}">{{ translated('gender') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <Dropdown v-model="gender" disabled :options="genders" optionLabel="name" optionValue="id" />		
            </div>
        </div>

    </div>

    <div class="profile-view-right card col-12 md:col-6">

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.email.$invalid && submited}">{{ translated('email') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="!unlockedAll" type="text" v-model="email"/>
            </div>
        </div> 

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.address.$invalid && submited}">{{ translated('address') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="locked" type="text" v-model="address"/>
            </div>
        </div>     
                        
        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.zip.$invalid && submited}">{{ translated('zip') }} </label>
            </div>
            <div class="col-4 sm:col-3">
                <InputText :disabled="locked" type="text" v-model="zip" :useGrouping="false"/>
            </div>
            <div class="col-8 sm:col-6">
                <InputText :disabled="locked" type="text" v-model="city"/>
            </div>                        
        </div>	
        

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label>{{ translated('area') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <Dropdown :disabled="locked || areaDisabled" v-model="selectedArea" :options="areas" optionLabel="name" optionValue="id" />		
            </div>
        </div>
        
        
        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
                <label :class="{'p-error': v$.selectedCountry.$invalid && submited}">{{ translated('country') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <Dropdown v-model="selectedCountry" :disabled="locked" :options="countries" optionLabel="name" optionValue="id" @change="onChangeCountry" />		
            </div>
        </div>

        <div class="p-fluid grid elementGroup">
            <div class="col-12  sm:col-3 labeldiv">
            <label :class="{'p-error': (v$.mobilephone.$invalid) && submited }">{{ translated('mobilephone') }} </label>
            </div>
            <div class="col-12 sm:col-9">
                <InputText :disabled="locked" type="text" v-model="mobilephone"/>
            </div>
        </div>  

    </div> 
    
</template>

<script>
import { email, required, sameAs, between, numeric, minLength, maxLength, requiredUnless, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";
import Calendar from 'primevue/calendar';

export default {    
    setup: () => ({ v$: useVuelidate() }),
    components: { Calendar },  
    emits: ['saved'],
    props: {
        locked: {
            type: Boolean,
            required: false,
            default: false 
        }
    },
    computed: {

    },
    data() {
        return { 
            uguid: '',           
            name: '',
            surname: '',
            personalregistrationnumber: '',
            personBirthDate:null,
            email: '',
            address: '',
            zip: '',
            city: '',
            country: '',
            selectedCountry: '',
            selectedArea: '',
            mobilephone: '',
            parentName: '',
            genders: [{ id: 0, name:'Muško' }, { id: 1, name: 'Žensko' }],
            gender: '',
            countries: [],
            areas: [],
            isLoading: false,
            submited: false,
            translated: computed(() => store.getters.getTranslate),
            unlockedAll: false,
            areaDisabled: false
        }
    },
    validations() {                      
        return {
          name: {  required },
          surname: { required },
          personalregistrationnumber: { required, minLength: minLength(13), maxLength: maxLength(13) },
          personBirthDate: { required },
          email:{ required, email },
          address:{ required },
          zip: { minLength: minLength(5), maxLength: maxLength(5), required },
          city: { required },            
          mobilephone: { required },
          selectedCountry: { required },
          parentName: { required },
          gender: { required }
        };
    },     
    watch: {

    },
    async mounted(){
        // debugger;
        const http = createHttp(false);
        const result1 = await http.get(process.env.VUE_APP_API_FOLDER + "/GetCountriesAndAreas");

        if(result1.status==200){
            this.countries = result1.data.countries;
            this.areas = result1.data.areas;

            const myCountry = this.countries.find(x => x.name.toLowerCase() == 'srbija');
            this.selectedCountry = myCountry.id;
        }
    },
    methods: {
        onChangeCountry(){
            
            const mycountry = this.countries.find(x => x.id == this.selectedCountry);
            // console.log(mycountry);
            if(mycountry.name.toLowerCase() != 'srbija'){
                this.selectedArea = null;
                this.areaDisabled  = true;
            } else {
                this.areaDisabled  = false;
            }

        },
        UnlockAll(){
            this.unlockedAll = true;
        },
        Clear() {
            debugger;
            this.name = '';
            this.surname = '';
            this.personalregistrationnumber = '';
            this.personBirthDate = null;
            this.email = '';
            this.address = '';
            this.zip = '';
            this.city = '';
            this.country = '';
            this.mobilephone = '';
            this.parentName = '';
            this.gender = '';    
            this.uguid = '00000000-0000-0000-0000-000000000000';        
        },
        async Load(id,isRoot){
            this.isLoading = true;

            debugger;
            const enpointName = isRoot==null || !isRoot ? '/getPerson' : '/getPersonRoot';
            
            let additionalParam = '';

            if(id != null && id.length > 0){
                additionalParam = '?id=' + id;
            }

            const http = createHttp(true);            
            const result = await http.get(process.env.VUE_APP_API_FOLDER + enpointName + additionalParam);

            if(result.status==200){
                let tmpBirthDate = '';

                if(result.data.birthDay != null){
                    const tmpDateArray = result.data.birthDay.split('-');
                    if(tmpDateArray.length > 2) {
                        tmpBirthDate = new Date(tmpDateArray[0],tmpDateArray[1]-1,tmpDateArray[2].split(' ')[0]);
                    }                    
                }

                debugger;
                this.name=result.data.name
                this.surname=result.data.surname
                this.personalregistrationnumber=result.data.personalRegistrationNumber
                this.personBirthDate=tmpBirthDate
                this.email=result.data.email
                this.address=result.data.address
                this.zip=result.data.zip
                this.city=result.data.city
                this.selectedCountry=result.data.countryId
                this.selectedArea=result.data.muncipalityId
                this.mobilephone=result.data.mobilePhone
                this.uguid = result.data.id
                this.gender = result.data.gender
                this.parentName = result.data.parentName
            }

            this.isLoading = false;
        },
        async Save(isRootPerson){
            this.submited = true;

            if (this.v$.$invalid) {
                return;
            };
            
            const formattedBirtdDate = `${this.personBirthDate.getFullYear()}-${String(this.personBirthDate.getMonth() + 1).padStart(2, '0')}-${String(this.personBirthDate.getDate()).padStart(2, '0')}`;

            debugger;
            let UpdateUser = {
                id:this.uguid, 
                name: this.name,
                email:this.email,
                personalregistrationnumber:this.personalregistrationnumber,
                birthDay: formattedBirtdDate,
                surname: this.surname,
                address: this.address,
                zip: this.zip.toString(),
                city: this.city,
                countryid: this.selectedCountry,
                muncipalityid: this.selectedArea,
                mobilephone: this.mobilephone,
                parentName: this.parentName,
                gender: this.gender
            }

            const http = createHttp(true); 

            try {        
                const enpointName = isRootPerson==null || !isRootPerson ? '/updatePerson' : '/updateRootPerson';
                const result = await http.post(process.env.VUE_APP_API_FOLDER + enpointName, UpdateUser);

                if(result.status==200) {
                    this.$emit('saved', result.data.person);
                } else {
                    // console.log(result.data);
                    
                }                             
            } 
            catch (error) {
                // console.log('Error:', error.response.data.error);
                this.$toast.add({severity:'error', summary:this.translated('error'), detail:error.response.data.error, life: 5000});
            }            
            
        },
        SetPerson(person) {
            //this.name = person.name;
            debugger;
            this.surname = person.surname;
            //this.personalregistrationnumber = person.personalRegistrationNumber;
            //this.personBirthDate = person.birthDay;
            this.email = person.email;
            this.address = person.address;
            this.zip = person.zip;
            this.city = person.city;
            this.selectedCountry = person.countryId;
            this.mobilephone = person.mobilePhone;
            //this.parentName = person.parentName;
            //this.gender = person.gender;     
            //this.$refs.nameInputControl.focus();       
            //var tmpEl = this.$refs.nameInputControl;
            var tmpEl = this.$refs.nameInputControl.$el.focus();
            //var tmpEl = this.$refs.nameInputControl.$el.querySelector('input');
        },
        GetJMBGData(jmbg) {
            // Provera pravilne dužine JMBG-a
            if (jmbg.length !== 13 || !/^\d+$/.test(jmbg)) {
                return {
                error:'JMBG nije validan',
                dan:-1,
                mesec:-1,
                godina:1,
                pol:'UNDEFINED'
            };
            }

            // Izvlačenje datuma rođenja
            const dan = jmbg.substring(0, 2);
            const mesec = jmbg.substring(2, 4);
            let godina = jmbg.substring(4, 7);
            // Dodavanje tačnog veka na osnovu treće cifre godine rođenja
            godina = (godina.charAt(0) === "9" ? "1" : "2") + godina;

            // Izvlačenje pola
            // // console.log('SPOL: ', jmbg.substring(9, 12));

            const bbb = parseInt(jmbg.substring(9, 12), 10);
            const pol = bbb < 500 ? 'M' : 'W';

            return {
                error:'',
                dan,
                mesec,
                godina,
                pol
            };
        },
        JMBGKeyDown() {
            this.JMBGLostFocus();
        },
        JMBGLostFocus() {
            let jmbgData = this.GetJMBGData(this.personalregistrationnumber);
            // console.log(jmbgData);

            if(jmbgData.error == ''){
                
                this.gender = this.genders.find(x => x.id == (jmbgData.pol == 'M' ? 0 : 1)).id;
                this.personBirthDate = new Date(jmbgData.godina, jmbgData.mesec - 1, jmbgData.dan);                                
            } else {
                this.gender = null;
                this.personBirthDate = null;
            }
        }

    }
}
</script>

<style scoped>


</style>